<div class="report-container retail-mall" [class.display-none]="showPropertyDetails">
    <app-report-sub-menu *ngIf="!showPropertyDetails" [menuList]="overViewMenu"
        (menuChangeValue)="menuChangeValue($event)" [activeTab]="activeTab"
        [activeTabName]="activeTabName"></app-report-sub-menu>
    <ng-container *ngIf="overViewLoading">
        <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"></app-skeleton-loader>
    </ng-container>

    <div class="report-tabsection" id="{{ retailInventoryMenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === retailInventoryMenuEnum.overview}">
        <div class="report-overview report-overview-4col" *ngIf="!overViewLoading && overViewSummary">
            <app-overview-card [card_title]="'reports.Estater_Tracked_Properties'" [untillDate]="overViewSummary.untillDate"
                [total_current]="overViewSummary.total_properties"
                [developerText]="overViewSummary.developed_properties"
                [underConstructionText]="overViewSummary.under_construction_properties"
                [showDeveloped]="true"></app-overview-card>

            <app-overview-card [card_title]="'reports.existingInventory'" [untillDate]="overViewSummary.untillDate"
                [total_current]="overViewSummary.existing_inventory" [uniType]="UnitTypeEnum.sqm"></app-overview-card>

            <app-overview-card [card_title]="'reports.supplyUnderConstructionPipeline'"
                [untillDate]="overViewSummary.untillDate" [total_current]="overViewSummary.supply_under_construction"
                [uniType]="UnitTypeEnum.sqm"></app-overview-card>

            <app-overview-card [card_title]="'reports.largestUpcomingProperty'"
                [total_current]="overViewSummary.largest_upcoming_property_area" [uniType]="UnitTypeEnum.sqm" [untillDate]="overViewSummary.untillDate"
                [areaName]="overViewSummary.largest_upcoming_property_name"
                [expectedDate]="overViewSummary.expectedDate"></app-overview-card>
        </div>

        <div class="property-line-chart">
            <div class="report-heading">
                <h2 class="detail-heading">{{'reports.supplyOfRetailSpace' | translate}} (sqm)</h2>
            </div>
            <ng-container *ngIf="trendsLoading">
                <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!trendsLoading">
                <ng-container
                    *ngTemplateOutlet="trendsData.length > 0 ? lineChartTemplate : noRecordsTemplate"></ng-container>
                <ng-template #lineChartTemplate>
                    <app-stacked-cluster-chart class="directionLtr" [data]="trendsData" [fillData]="true"></app-stacked-cluster-chart>
                </ng-template>
            </ng-container>

        </div>


        <div class="property-line-chart">
            <div class="report-heading">
                <h2 class="detail-heading">{{'reports.topNeighborhoodGla' | translate}} (sqm)</h2>
                <app-dropdown-radio-selection [dropDownOption]="developerDropdown"
                    (dropDownValue)="dropDownChange($event)" [showInvalueText]="false"></app-dropdown-radio-selection>

            </div>

            <ng-container *ngIf="neighbhoodGlaShareLoading">
                <app-skeleton-loader [reportType]="chartView.horizontalBarChart"></app-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!neighbhoodGlaShareLoading">
                <ng-container
                    *ngTemplateOutlet="neighGlashare.length > 0 ? GlaShare : noRecordsTemplate"></ng-container>
                <ng-template #GlaShare>
                    <div class="sorted-bar" *ngIf="!neighbhoodGlaShareLoading && neighGlashare.length > 0">
                        <div class="bar-wrapper" *ngFor="let item of neighGlashare; let i=index;">
                            <div class="progress d-flex align-items-center" *ngIf="item.gla">
                                <h5 [title]="item.neighborhood">{{item.neighborhood}}</h5>
                                <section>
                                    <div class="bar" [style.width.%]="item.width" [style.opacity]="item.opacity">
                                    </div>
                                    <small class="directionLtr">{{item.gla | number:'1.0-1'}}
                                    </small>
                                </section>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </div>

        <div class="property-infod">
            <div class="property-information">
                <div class="retail-heading">
                    <h2 class="detail-heading">{{'reports.topdevelopersbygla' | translate}} <br> (sqm)</h2>
                    <app-dropdown-radio-selection [dropDownOption]="developerDropdown"
                        (dropDownValue)="dropDownChange($event, 'developer')"
                        [showInvalueText]="false"></app-dropdown-radio-selection>
                </div>
                <ng-container *ngIf="propertyCountLoading">
                    <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!propertyCountLoading">
                    <ng-container
                        *ngTemplateOutlet="propertyCount.length > 0 ? barChartTemplate : noRecordsTemplate"></ng-container>
                    <ng-template #barChartTemplate>
                        <app-report-charts [data]="propertyCount" [chartType]="chartView.barChart"
                            [name]="'houseVillasbarChart'" [isBorder]="false" [height]="'250px'"></app-report-charts>
                    </ng-template>
                </ng-container>
            </div>

            <div class="property-information">
                <h2 class="detail-heading">{{'reports.glaShareConstruction' | translate}} </h2>
                <ng-container *ngIf="glashareLoading">
                    <app-skeleton-loader [reportType]="chartView.pieChart"></app-skeleton-loader>
                </ng-container>

                <ng-container *ngIf="!glashareLoading">
                    <ng-container
                        *ngTemplateOutlet="glashare.length > 0 ? pieChartTemplate : noRecordsTemplate"></ng-container>
                    <ng-template #pieChartTemplate>
                        <app-report-charts class="directionLtr" [isBorder]="false" [height]="'250px'" [data]="glashare"
                            [chartType]="chartView.pieChart" [is_v2_report]="true"></app-report-charts>
                    </ng-template>
                </ng-container>
            </div>
        </div>


        <!-- <div class="property-line-chart">
            <div class="report-heading">
                <h2 class="detail-heading">{{trendsText | translate}}</h2>

                <app-dropdown-radio-selection [dropDownOption]="trendsDropdown"
                    (dropDownValue)="trendsdropDownChange($event)"
                    [showInvalueText]="false"></app-dropdown-radio-selection>



            </div>
            <ng-container
                *ngTemplateOutlet="trendsData.length > 0 ? lineChartTemplate : noRecordsTemplate"></ng-container>
            <ng-template #lineChartTemplate>
                <app-line-series-chart class="directionLtr" [data]="trendsData"></app-line-series-chart>
            </ng-template>
        </div> -->


    </div>

    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailInventoryMenuEnum.properties}"
        id="{{ retailInventoryMenuEnum.properties }}">

        <app-report-year-dropdown [reportType]="'properties'"
            (selectedYear)="selectedYear($event)"></app-report-year-dropdown>

        <div class="report-model">

            <app-datatable-title [title]="'reports.projectsProperties'" [count]="propertiesCount"></app-datatable-title>

<app-retail-inventory-properties [showLoader]="!propertiesLoading"[tableColumns]="propertiesColumns"
    [dataLength]="propertiesCount" [tableData]="propertiesData"
    (pageEvent)="onPageEvent($event, retailInventoryMenuEnum.properties)"
    (sort)="sortData($event, retailInventoryMenuEnum.properties)"
    (excelDownload)="downloadExcel($event, 'retail_inventory_properties_v2', 'a')"
    [downloadLoading]="downloadLoading['a']">
</app-retail-inventory-properties>
            <!-- <app-report-datatable [showLoader]="!propertiesLoading"
                [ngClass]="{'activeTable': tableName == retailInventoryMenuEnum.properties}"
                (lastClickedTable)="lastClickedTable($event, retailInventoryMenuEnum.properties)"
                [tableColumns]="propertiesColumns" [dataLength]="propertiesCount" [tableData]="propertiesData"
                (pageEvent)="onPageEvent($event, retailInventoryMenuEnum.properties)"
                (sort)="sortData($event, retailInventoryMenuEnum.properties)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'retail_inventory_properties_v2', 'a')" [expandColumn]="false"
                [downloadLoading]="downloadLoading['a']">
            </app-report-datatable> -->
        </div>
    </div>

    <!-- <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailInventoryMenuEnum.departments}"
        id="{{ retailInventoryMenuEnum.departments }}">

        <app-report-year-dropdown [reportType]="'departments'"
            (selectedYear)="selectedYear($event)"></app-report-year-dropdown>

        <div class="report-model"> -->

            <!-- <app-datatable-title [title]="'reports.departments'" [count]="departmentsCount"></app-datatable-title> -->

            <!-- <app-retail-inventory-department
                [showLoader]="!departmentsLoading" [tableColumns]="departmentsColumns" [dataLength]="departmentsCount"
                [tableData]="departmentsdata" (pageEvent)="onPageEvent($event, retailInventoryMenuEnum.departments)"
                (sort)="sortData($event, retailInventoryMenuEnum.departments)"
                (excelDownload)="downloadExcel($event, 'retail_inventory_departments', 'b')"
                [downloadLoading]="downloadLoading['b']"
                [dropDownOption]="unitSizeDropdown">
            </app-retail-inventory-department> -->
            <!-- <app-report-datatable class="rri-rentunitsize-table"
                [ngClass]="{'activeTable': tableName == retailInventoryMenuEnum.departments}"
                (lastClickedTable)="lastClickedTable($event, retailInventoryMenuEnum.departments)"
                [showLoader]="!departmentsLoading" [tableColumns]="departmentsColumns" [dataLength]="departmentsCount"
                [tableData]="departmentsdata" (pageEvent)="onPageEvent($event, retailInventoryMenuEnum.departments)"
                (sort)="sortData($event, retailInventoryMenuEnum.departments)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'retail_inventory_departments', 'b')" [expandColumn]="true"
                [tableExpandColumns]="departmentExpandColumns" [downloadLoading]="downloadLoading['b']"
                (dropDownValue)="departmentDropdownChange($event)"
                [dropDownOption]="unitSizeDropdown">
            </app-report-datatable> -->

        <!-- </div>
    </div> -->

    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === retailInventoryMenuEnum.tenants}"
        id="{{ retailInventoryMenuEnum.tenants }}">

        <app-report-year-dropdown [reportType]="'tenants'"
            (selectedYear)="selectedYear($event)"></app-report-year-dropdown>

        <div class="report-model">

            <app-datatable-title [title]="'reports.tentants'" [count]="tentantsCount"></app-datatable-title>

            <app-retail-inventory-tenants [showLoader]="!tentantsLoading"
                [tableColumns]="tentantsColumns" [dataLength]="tentantsCount" [tableData]="tentantsdata"
                (pageEvent)="onPageEvent($event, retailInventoryMenuEnum.tenants)"
                (sort)="sortData($event, retailInventoryMenuEnum.tenants)"
                (excelDownload)="downloadExcel($event, 'retail_inventory_tenants', 'c')"
                [downloadLoading]="downloadLoading['c']"
                [dropDownOption]="unitSizeDropdown">
            </app-retail-inventory-tenants>
            <!-- <app-report-datatable [showLoader]="!tentantsLoading"
                [ngClass]="{'activeTable': tableName == retailInventoryMenuEnum.tenants}"
                (lastClickedTable)="lastClickedTable($event, retailInventoryMenuEnum.tenants)"
                [tableColumns]="tentantsColumns" [dataLength]="tentantsCount" [tableData]="tentantsdata"
                (pageEvent)="onPageEvent($event, retailInventoryMenuEnum.tenants)"
                (sort)="sortData($event, retailInventoryMenuEnum.tenants)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'retail_inventory_tenants', 'c')" [expandColumn]="false"
                [downloadLoading]="downloadLoading['c']"
                (dropDownValue)="tenantDropdownChange($event)"
                [dropDownOption]="unitSizeDropdown">
            </app-report-datatable> -->
        </div>
    </div>
</div>

<ng-template #noRecordsTemplate>
    <div class="noRecordsFound">{{'reports.no_records_found' | translate}}</div>
</ng-template>
